<script setup lang="ts">
import {
  type TextQuestion,
  getQuestionStatusName,
  statuses,
} from '../calendarQuestion'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import DolphinRadioButtonInContainer from '@/components/molecules/DolphinRadioButtonInContainer.vue'
import { computed } from 'vue'

const statusOptions = computed(() => {
  return statuses.map(status => ({
    value: status,
    label: getQuestionStatusName(status),
  }))
})

const model = defineModel<TextQuestion>()
</script>

<template>
  <div v-if="model" :class="$style.navigation">
    <div :class="$style.questionTextSection">
      <label>質問内容</label>
      <DolphinTextInput
        v-model="model.questionText"
        type="text"
        :class="$style.input"
      />
    </div>

    <div :class="$style.statusSection">
      <label>任意・必須</label>
      <div :class="$style.statusRadioGroup">
        <DolphinRadioButtonInContainer
          v-for="option in statusOptions"
          :key="option.value"
          :class="$style.statusRadioGroup__option"
          name="status"
          v-model="model.status"
          :value="option.value"
        >
          {{ option.label }}
        </DolphinRadioButtonInContainer>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.navigation {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.input {
  font-size: 16px;
}

.questionTextSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.statusSection {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.statusRadioGroup {
  display: flex;
  gap: 8px;

  &__option {
    flex: 1;
  }
}
</style>
